<template>
  <b-modal
    :id="id"
    header-bg-variant="dark"
    header-text-variant="white"
    scrollable
    :body-class="bodyClass"
    :cancel-disabled="cancelDisabled"
    :cancel-title="cancelTitle"
    :centered="centered"
    :content-class="contentClass"
    :hide-footer="hideFooter"
    :hide-header="hideHeader"
    :lazy="lazy"
    :ok-title="okTitle"
    :ok-only="okOnly"
    :ok-variant="okVariant"
    :size="size"
    :title="title"
    :title-class="titleClass"
    :ok-disabled="okDisabled"
    @ok="ok"
    @close="close"
    @hidden="hidden"
    @shown="shown"
  >
    <template
      v-if="$slots.title"
      #modal-title
    >
      <slot name="title" />
    </template>

    <template
      v-if="$slots.footer"
      #modal-footer
    >
      <slot name="footer" />
    </template>
    <slot />
  </b-modal>
</template>

<script>
import '@/import-jquery.js';
import 'jquery-ui-dist/jquery-ui.js';

export default {
  name: 'IFEModal',
  props: {
    okDisabled: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: '',
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    cancelTitle: {
      type: String,
      default: 'Cancel',
    },
    centered: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: '',
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    okOnly: {
      type: Boolean,
      default: false,
    },
    okTitle: {
      type: String,
      default: 'OK',
    },
    okVariant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'xl',
    },
    title: {
      type: String,
      required: true,
    },
    titleClass: {
      type: [String, Array],
      default: '',
    },
  },
  methods: {
    close(e) {
      this.$emit('close', e);
    },
    hidden(e) {
      this.$emit('hidden', e);
    },
    ok(e) {
      this.$emit('ok', e);
    },
    shown(e) {
      this.$emit('shown', e);
      this.makeDraggable();
    },
    makeDraggable() {
      if (this.draggable) {
        this.$nextTick(() => {
          $('.modal-dialog').draggable({
            handle: '.modal-header',
          });
        });
      }
    },
  },
};
</script>

<style scoped>

</style>
